export default __webpack_public_path__ + "static/media/bitpurple.d60f641a.svg";